<template>
	<div class="container">
		<header class="page-header">
			<center><h1 class="page-title-2">Will Be Updated!!!</h1></center>
		</header>
		<div class="gap gap-big"></div>
		<div class="gap gap-big"></div>
		<div class="gap gap-small"></div>
	</div>
</template>

<script>
	export default {
		components: {
			//
		},
		data() {
			return {
				authKey: null
			}
		},
		created() {
			//
		}
	}
</script>
